import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { PageheaderComponent } from '../../../../Components/pageheader/pageheader.component';
import { ACADEMIC_DATA } from '../academics.data';
import { RouterOutlet } from '@angular/router';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '../../../base.component';
import { SchoolApiService } from '../../../../Services/schoolApi.service';
import { AutoUnsubscribe } from '../../../../Services/autoUnsubscribe.service';

@AutoUnsubscribe()
@Component({
  selector: 'app-admission',
  standalone: true,
  imports: [PageheaderComponent, TranslateModule, RouterOutlet, CommonModule],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './admission.component.html',
  styleUrl: './admission.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdmissionComponent extends BaseComponent {
  public ACADEMIC_DATA = ACADEMIC_DATA;
  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
  }
}
